// MissionSection organism component
import { Heading, Text } from "../atoms";
import { useLandingContent } from "../../contexts/LandingContentContext";

export const MissionSection = () => {
  const { mission } = useLandingContent();

  return (
    <section id="about" className="py-28 bg-paper">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <p className="text-xs font-semibold tracking-widest uppercase text-terracotta-600 mb-4">
          {mission.eyebrow}
        </p>
        <Heading
          level={2}
          className="font-display text-4xl md:text-5xl text-ink leading-snug mb-8"
        >
          {mission.heading}
        </Heading>
        <div className="flex items-center justify-center gap-3 mb-10">
          <span className="block w-8 h-px bg-terracotta-300" />
          <span className="block w-2 h-2 rounded-full bg-terracotta-600" />
          <span className="block w-8 h-px bg-terracotta-300" />
        </div>
        <Text
          size="lg"
          className="text-ink-soft leading-relaxed text-lg md:text-xl"
        >
          {mission.body}
        </Text>
      </div>
    </section>
  );
};
